var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-wrap justify-center"},_vm._l((_vm.items),function(item,index){return _c('div',{key:item.key,class:[
            _vm.isDesktop ? 'p-2' : 'p-1.5',
            _vm.isHero(index)
                ? _vm.isDesktop
                    ? 'w-full max-w-lg'
                    : 'w-full'
                : _vm.isDesktop
                ? 'w-1/3'
                : 'w-1/2'
        ]},[_c(item.href ? 'a' : 'div',_vm._b({tag:"component",staticClass:"group relative block w-full overflow-hidden rounded-2xl bg-stack-text no-underline shadow-xl",class:[
                _vm.isHero(index)
                    ? 'aspect-banner'
                    : _vm.isDesktop
                    ? 'h-56'
                    : 'h-40',
                { 'cursor-pointer': item.href }
            ],attrs:{"aria-label":item.title},on:{"click":_vm.onClick}},'component',_vm.linkAttrs(item),false),[(item.imageUrl)?_c('img',{staticClass:"absolute inset-0 h-full w-full transform object-cover transition-transform duration-700 ease-out group-hover:scale-110",attrs:{"src":item.imageUrl,"alt":item.imageAlt}}):_c('div',{staticClass:"absolute inset-0"},[_vm._t("placeholder",null,{"item":item})],2)])],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }